import * as api from '../../requests.js'
import {
  SET_TRADEMARK_HISTORY,
  SET_RECORD_DETAILS,
  SET_RECORD_HISTORY,
  SET_RECORD_NOTES,
  SET_ENUM_CATEGORY,
  SET_UCC_AMENDMENT,
  SET_UCC_HISTORY,
  SET_USER_RIGHTS_OPTIONS,
  SET_FREQUENT_PAYOR_INFO,
  SET_FREQUENT_PAYOR_ACCOUNTS,
  SET_FREQUENT_PAYOR_TRANSACTIONS,
  SET_TEMP_NUM,
  SET_SELECTED_HISTORY_RECORD
} from './RecordDetailsReducer'
import { setErrorToast, setSuccessToast } from '../../actions'

const frequentPayorLabel = process.env.FREQUENT_PAYOR_LABEL

export const getInitialTrademarkRecordData = (id) => {
  return (dispatch, getState) => {
    api.FETCH_TRADEMARK_RECORD_NOTES(
      id,
      (notes) => {
        dispatch({ type: SET_RECORD_NOTES, notes: notes })
      },
      (err) => console.error(err)
    )

    api.FETCH_TRADEMARK_RECORD_DETAILS(
      id,
      (record) => {
        dispatch({ type: SET_RECORD_DETAILS, record: record })
        dispatch({ type: SET_TRADEMARK_HISTORY, history: record.history })
      },
      (err) => console.error(err)
    )
  }
}

export const addTrademarkNote = (note, fileNum) => {
  return (dispatch, getState) => {
    const { TrademarkRecordId } = getState().record.recordDetails
    api.SAVE_NOTE(
      810,
      TrademarkRecordId,
      note,
      (note) => {
        api.FETCH_TRADEMARK_RECORD_NOTES(
          fileNum,
          (notes) => {
            // console.log('notes: ', notes)
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        dispatch(setErrorToast('Failed to Save Note'))
        console.error(err)
      }
    )
  }
}

export const editTrademarkNote = (note, fileNum) => {
  return (dispatch) => {
    api.EDIT_NOTE(
      note,
      () => {
        api.FETCH_TRADEMARK_RECORD_NOTES(
          fileNum,
          (notes) => {
            // console.log('notes: ', notes)
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        dispatch(setErrorToast('Failed to Edit Note'))
        console.error(err)
      }
    )
  }
}

export const deleteTrademarkNote = (noteId, fileNum) => {
  return (dispatch) => {
    api.DELETE_NOTE(
      noteId,
      () => {
        api.FETCH_TRADEMARK_RECORD_NOTES(
          fileNum,
          (notes) => {
            // console.log('notes: ', notes)
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        dispatch(setErrorToast('Failed to Delete Note'))
        console.error(err)
      }
    )
  }
}

export const getDataRequestRecordData = (dataReqNum) => {
  return (dispatch) => {
    api.FETCH_DATA_REQUEST_RECORD_DETAILS(
      dataReqNum,
      (details) => {
        dispatch({ type: SET_RECORD_DETAILS, record: details })
      },
      (err) => console.error(err)
    )
  }
}

export const addDataRequestNote = (note, dataReqNum) => {
  return (dispatch, getState) => {
    return api.SAVE_NOTE(
      869,
      dataReqNum,
      note,
      () => {
        dispatch(getEntityNotes(869, dataReqNum))
      },
      (err) => {
        dispatch(setErrorToast('Failed to Save Note'))
        console.error(err)
      }
    )
  }
}

export const editDataRequestNote = (note, dataReqNum) => {
  return (dispatch) => {
    return api.EDIT_NOTE(
      note,
      () => {
        dispatch(getEntityNotes(869, dataReqNum))
      },
      (err) => {
        dispatch(setErrorToast('Failed to Edit Note'))
        console.error(err)
      }
    )
  }
}

export const deleteDataRequestNote = (noteId, dataReqNum) => {
  return (dispatch) => {
    return api.DELETE_NOTE(
      noteId,
      () => {
        dispatch(getEntityNotes(869, dataReqNum))
      },
      (err) => {
        dispatch(setErrorToast('Failed to Delete Note'))
        console.error(err)
      }
    )
  }
}

export const getInitialBusinessEntityRecordData = (id, amendmentNum = null) => {
  return (dispatch, getState) => {
    api.FETCH_BUSINESS_ENTITY_RECORD_DETAILS(
      id,
      (details) => {
        dispatch({ type: SET_RECORD_DETAILS, record: details })
      },
      (err) => console.error(err)
    )

    api.FETCH_BUSINESS_ENTITY_RECORD_DETAIL_HISTORY(
      id,
      (history) => {
        dispatch({ type: SET_RECORD_HISTORY, history: history })
        // console.log(amendmentNum);
        if (amendmentNum) {
          // console.log("finding history record to update.")
          dispatch({
            type: SET_SELECTED_HISTORY_RECORD,
            selectedHistoryRecord:
              (history.amendments || []).find((amendment) => amendment.NUM === amendmentNum) || {}
          })
        }
      },
      (err) => console.error(err)
    )
  }
}

export const updateBusinessEntity = (entityData) => {
  return (dispatch) => {
    api.UPDATE_BUSINESS_ENTITY_RECORD_DETAIL(
      entityData,
      (details) => {
        // console.log("updated details", details);
        dispatch(getInitialBusinessEntityRecordData(entityData.FILING_NUM))
        dispatch(setSuccessToast('Business record updated successfully.'))
      },
      (err) => {
        dispatch(setErrorToast('Failed to update business record.'))
        console.error(err)
      }
    )
  }
}

export const voidBEAmendment = (voidData, amendmentNum) => {
  return (dispatch) => {
    api.VOID_BE_AMENDMENT(
      voidData,
      (details) => {
        dispatch(getInitialBusinessEntityRecordData(voidData.FILING_NUM, amendmentNum))
        dispatch(setSuccessToast('Business Amendment voided successfully.'))
      },
      (err) => {
        dispatch(setErrorToast('Failed to void amendment.'))
        console.error(err)
      }
    )
  }
}

export const addBusinessEntityNote = (note, fileNum) => {
  return (dispatch, getState) => {
    const { ID_NUM } = getState().record.recordDetails
    return api.SAVE_NOTE(
      169,
      ID_NUM,
      note,
      () => {
        //Notes
      },
      (err) => {
        dispatch(setErrorToast('Failed to Save Note'))
        console.error(err)
      }
    )
  }
}

export const getUccAmendmentById = (id) => {
  return (dispatch) => {
    api.FETCH_UCC_AMENDMENT_BY_ID(
      id,
      (data) => {
        // console.log(data)
        dispatch(setUccAmendment(data))
        api.FETCH_UCC_DOCUMENT_NOTES(
          data.UCCRecordId,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      },
      (err) => console.error(err)
    )
  }
}

export const getUccAmendmentByNum = (num, callback) => {
  return (dispatch) => {
    api.FETCH_UCC_AMENDMENT_BY_NUM(
      num,
      (data) => {
        // console.log(data)
        dispatch(setUccAmendment(data))
        api.FETCH_UCC_DOCUMENT_NOTES(
          data.UCCRecordId,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
        if (callback) callback()
      },
      (err) => {
        console.error(err)
        if (callback) callback()
      }
    )
  }
}

const setUccAmendment = (data) => ({
  type: SET_UCC_AMENDMENT,
  ucc: data
})

export const getUccAmendmentTypesEnum = () => {
  //FETCH_UCC_AMENDMENT_TYPES
  return (dispatch) => {
    api.FETCH_UCC_AMENDMENT_TYPES(
      (categoryEnum) => {
        // console.log('UCC_AMENDMENT_TYPE_IDS', categoryEnum);
        dispatch({
          type: SET_ENUM_CATEGORY,
          category: 'UCC_AMENDMENT_TYPE_IDS',
          categoryEnum: categoryEnum
        })
      },
      (err) => console.error(err)
    )
  }
}

export const getUccAmendmentActionTypesEnum = () => {
  //FETCH_UCC_AMENDMENT_ACTION_TYPES
  return (dispatch) => {
    api.FETCH_UCC_AMENDMENT_ACTION_TYPES(
      (categoryEnum) => {
        // console.log('UCC_AMENDMENT_ACTION_TYPE_IDS', categoryEnum);
        dispatch({
          type: SET_ENUM_CATEGORY,
          category: 'UCC_AMENDMENT_ACTION_TYPE_IDS',
          categoryEnum: categoryEnum
        })
      },
      (err) => console.error(err)
    )
  }
}

export const getUccPartyActionIdsEnum = () => {
  //FETCH_UCC_PARTY_ACTION_IDS
  return (dispatch) => {
    api.FETCH_UCC_PARTY_ACTION_IDS(
      (categoryEnum) => {
        // console.log('UCC_PARTY_ACTION_IDS', categoryEnum)
        dispatch({
          type: SET_ENUM_CATEGORY,
          category: 'UCC_PARTY_ACTION_IDS',
          categoryEnum: categoryEnum
        })
      },
      (err) => console.error(err)
    )
  }
}

export const getUccAmendmentHistoryList = (id) => {
  return (dispatch) => {
    api.FETCH_UCC_AMENDMENT_HISTORY(
      id,
      (data) => {
        // console.log('ucc amendment history', data)
        dispatch({ type: SET_UCC_HISTORY, data: data })
      },
      (err) => console.error(err)
    )
  }
}

export const getWebUserInfo = (id) => {
  return (dispatch) => {
    api.FETCH_WEB_USER_INFO(
      id,
      (userData) => {
        // console.log('web user data', userData);
        dispatch({ type: SET_RECORD_DETAILS, record: userData })
      },
      (err) => console.error(err)
    )

    api.FETCH_WEB_USER_RIGHTS_OPTIONS(
      (data) => {
        // console.log('user rights options',data);
        dispatch({ type: SET_USER_RIGHTS_OPTIONS, data: data })
      },
      (err) => console.error(err)
    )
  }
}

export const getFrequentPayorInfo = (payorNum) => {
  return (dispatch) => {
    api.GET_FREQUENT_PAYOR(
      payorNum,
      (data) => {
        dispatch({ type: SET_FREQUENT_PAYOR_INFO, data: data })

        api.GET_FREQUENT_PAYOR_GET_COMMENTS(
          data.id,
          (comments) => {
            // console.log('comments: ',comments)
            dispatch({ type: SET_RECORD_NOTES, notes: comments })
          },
          (err) => console.error(err)
        )

        api.GET_FREQUENT_PAYOR_LINKED_ACCOUNTS(
          data.id,
          (accounts) => {
            // console.log('accounts: ', accounts)
            dispatch({ type: SET_FREQUENT_PAYOR_ACCOUNTS, data: accounts })
          },
          (err) => console.error(err)
        )

        api.GET_FREQUENT_PAYOR_TRANSACTIONS(
          data.id,
          (transactions) => {
            // console.log('transactions: ', transactions)
            dispatch({ type: SET_FREQUENT_PAYOR_TRANSACTIONS, data: transactions })
          },
          (err) => console.error(err)
        )
      },
      (err) => console.error(err)
    )
  }
}

export const saveFrequentPayorComment = (noteText) => {
  return (dispatch, getState) => {
    const { id = null } = getState().record.frequentPayor
    const sourceTypes = getState().record.idEnums['SOURCE_TYPE']
    api.SAVE_NOTE(
      sourceTypes['Frequent Payor'],
      id,
      noteText,
      () => {
        api.GET_FREQUENT_PAYOR_GET_COMMENTS(
          id,
          (comments) => {
            dispatch({ type: SET_RECORD_NOTES, notes: comments })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Save Comment'))
      }
    )
  }
}

export const editFrequentPayorComment = (note) => {
  return (dispatch, getState) => {
    const { id = null } = getState().record.frequentPayor
    api.EDIT_NOTE(
      note,
      () => {
        api.GET_FREQUENT_PAYOR_GET_COMMENTS(
          id,
          (comments) => {
            dispatch({ type: SET_RECORD_NOTES, notes: comments })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Edit Comment'))
      }
    )
  }
}

export const deleteFrequentPayorComment = (noteId) => {
  return (dispatch, getState) => {
    const { id = null } = getState().record.frequentPayor
    api.DELETE_NOTE(
      noteId,
      () => {
        api.GET_FREQUENT_PAYOR_GET_COMMENTS(
          id,
          (comments) => {
            dispatch({ type: SET_RECORD_NOTES, notes: comments })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Delete Comment'))
      }
    )
  }
}

export const updateFrequentPayor = (payor, payorNum) => {
  return (dispatch) => {
    api.UPDATE_FREQUENT_PAYOR(
      payor,
      (updatedPayor) => {
        dispatch({ type: SET_FREQUENT_PAYOR_INFO, data: updatedPayor })
        dispatch(setSuccessToast(`Updated ${frequentPayorLabel || `Frequent Payor`}`))
        dispatch(getFrequentPayorInfo(payorNum))
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast(`Failed to Update ${frequentPayorLabel || `Frequent Payor`}`))
        dispatch(getFrequentPayorInfo(payorNum))
      }
    )
  }
}

export const getUccInfoRequestData = (reqNum) => {
  return (dispatch) => {
    api.FETCH_UCC_INFO_REQUEST_DATA(
      reqNum,
      (data) => {
        dispatch({ type: SET_RECORD_DETAILS, record: data })
      },
      (err) => console.error(err)
    )
  }
}

export const saveUccDocumentNote = (noteText) => {
  return (dispatch, getState) => {
    const { UCCRecordId } = getState().record.ucc
    return api.SAVE_NOTE(
      2000,
      UCCRecordId,
      noteText,
      (data) => {
        // requery the list.
        api.FETCH_UCC_DOCUMENT_NOTES(
          UCCRecordId,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Save Note'))
      }
    )
  }
}

export const editUccDocumentNote = (note) => {
  return (dispatch, getState) => {
    const { UCCRecordId } = getState().record.ucc
    return api.EDIT_NOTE(
      note,
      () => {
        // requery the list.
        api.FETCH_UCC_DOCUMENT_NOTES(
          UCCRecordId,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Edit Note'))
      }
    )
  }
}

export const deleteUccDocumentNote = (noteId) => {
  return (dispatch, getState) => {
    const { UCCRecordId } = getState().record.ucc
    return api.DELETE_NOTE(
      noteId,
      () => {
        // requery the list.
        api.FETCH_UCC_DOCUMENT_NOTES(
          UCCRecordId,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Delete Note'))
      }
    )
  }
}

export const saveNewNote = (note, sourceID, id) => {
  return (dispatch, getState) => {
    api.SAVE_NOTE(
      sourceID,
      id,
      note,
      () => dispatch(getEntityNotes(sourceID, id)),
      (err) => {
        dispatch(setErrorToast('Failed to Save Note'))
        console.error(err)
      }
    )
  }
}

export const editNote = (note, sourceID, id) => {
  return (dispatch, getState) => {
    api.EDIT_NOTE(
      note,
      () => dispatch(getEntityNotes(sourceID, id)),
      (err) => {
        dispatch(setErrorToast('Failed to Edit Note'))
        console.error(err)
      }
    )
  }
}

export const deleteNote = (noteId, sourceID, id) => {
  return (dispatch, getState) => {
    api.DELETE_NOTE(
      noteId,
      () => dispatch(getEntityNotes(sourceID, id)),
      (err) => {
        dispatch(setErrorToast('Failed to Delete Note'))
        console.error(err)
      }
    )
  }
}

export const getEntityNotes = (sourceID, id) => (dispatch) => {
  return api.FETCH_ENTITY_NOTES(
    sourceID,
    id,
    (notes) => {
      dispatch({ type: SET_RECORD_NOTES, notes: notes })
    },
    (err) => console.error(err)
  )
}

export const getFacsimileSignatureDetails = (facsimileNum) => {
  return (dispatch) => {
    return api.GET_FACSIMILE_SIGNATURE_DETAILS(
      facsimileNum,
      (record) => {
        dispatch({ type: SET_RECORD_DETAILS, record: record })
      },
      (err) => console.error(err)
    )
  }
}

export const getEditRecordUrl = (name, recordNum, record) => {
  return (dispatch) => {
    return api.GET_EDIT_RECORD_URL(
      name, 
      recordNum,
      (redirectUrl) => {
        dispatch({ type: SET_RECORD_DETAILS, record: {...record, EditRedirectUrl: redirectUrl}})
      },
      (err) => console.error(err)
    )
  }
}
